import { useCallback, useEffect } from 'react';
import { isSome, Option } from 'fp-ts/Option';
import { DeleteWidgetCriteriaBuilder } from 'use-case/widgets/delete/deleteWidgetCriteria';
import { useWidget } from 'adapter/in/dashboards/context/Widget/data';
import { useCase } from 'adapter/in/common/hooks/useCase';
import { DeleteData } from 'domain/types';
import { dispatchWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';

const useDeleteWidget = (
    dashboardId: string,
    widgetId: string
): { delete: () => void; isLoading: boolean; data: Option<DeleteData>; success: boolean; error: boolean } => {
    const { deleteWidget } = useWidget();
    const { data, error, execute: remove, isLoading } = useCase(deleteWidget, false);
    const { toggleReloadWidgets } = dispatchWidgetsView();

    const handleDelete = useCallback(
        () => remove(DeleteWidgetCriteriaBuilder.create().withDashboardId(dashboardId).withWidgetId(widgetId).build()),
        [dashboardId, widgetId]
    );

    useEffect(() => {
        if (isSome(data)) {
            toggleReloadWidgets(true);
        }
    }, [data]);

    return {
        delete: handleDelete,
        isLoading,
        data,
        success: !!isSome(data),
        error: !!isSome(error),
    };
};

export default useDeleteWidget;
